var map = {
	"./logo-title.png": 63,
	"./logo-title@2x.png": 2
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img ^\.\/logo\-title.*\.png$
// module id = 120
// module chunks = d-game